import './styles/main.css';
import { FPSGame } from './game/FPSGame';
import { HUD } from './ui/HUD';

function init() {
  const canvasContainer = document.getElementById('canvas-container');
  const hudRoot = document.getElementById('hud-root');

  if (!canvasContainer || !hudRoot) {
    console.error('Missing root containers');
    return;
  }

  const game = new FPSGame(canvasContainer);
  const hud = new HUD(game, hudRoot);

  game.start();

  let lastTime = performance.now();
  function hudLoop() {
    requestAnimationFrame(hudLoop);
    const now = performance.now();
    const dt = (now - lastTime) / 1000;
    lastTime = now;
    hud.update(dt);
  }
  hudLoop();
}

window.addEventListener('DOMContentLoaded', init);
